import { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import { Images } from "../../helper/images";
import MaturityLevelAnalyzer from "./maturity-level-analyzer";
import AIEvaluationTable, { TaskStatus } from "./ai-evaluation-table";
import { useAppContext } from "../../context/app.context";
import { getStorageData } from "../../service/storage.service";
import { Constant, SECTION_NAMES } from "../../helper/constant";
import { useNavigate } from "react-router-dom";
import { DisabledNavLink } from "../../component/sidemenu";

const AIMaturityEvalution = () => {
    const sliderRef = useRef(null);
    const { aiMaturityEval, getAIMaturityEvaluation } = useAppContext();
    const [currentIndex, setCurrentIndex] = useState(0);
    const navigate = useNavigate();

    useEffect(() => {
        if (!aiMaturityEval) {
            getAIMaturityEvaluation();
        }
    }, [aiMaturityEval]);

    const onSlideChange = (i) => {
        setCurrentIndex(i)
        if (i === 4) {
            getAIMaturityEvaluation();
        }
    }

    const render = () => {
        const sliderConfig = {
            dots: true,
            infinite: false,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
        };
        const companyName = getStorageData(Constant.STORAGE_KEYS.USER_INFO)?.userInfo.org_name;
        return (
            <>
                <div className="d-flex justify-content-between align-items-center">
                    <h3 className=" text-blue h4 mb-3 mb-0">{SECTION_NAMES.AI_MATURITY_EVALUATION}</h3>
                    <div className="d-flex align-items-center gap-4">
                        <DisabledNavLink to='/company-intro'><i class="fa fa-angle-left" style={{ fontSize: 32 }} aria-hidden="true"></i><p className="m-0 p-0">{SECTION_NAMES.COMAPANY_INFO}</p></DisabledNavLink>
                        <DisabledNavLink disabled={currentIndex !== 5} to='/gap-analysis'><p className="m-0 p-0">{SECTION_NAMES.GAP_ANALYSIS}</p><i class="fa fa-angle-right" aria-hidden="true" style={{ fontSize: 32 }} ></i></DisabledNavLink>
                    </div>
                </div>
                <Slider ref={sliderRef} className="evaluationslider navigatorslider px-5" {...sliderConfig} afterChange={onSlideChange}>
                    <div className="slide-item">
                        <div className="text-dark"><strong>Garter AI Maturity framework is an Industry Standard, well recognized and respected framework</strong></div>
                        <div className="mt-3 page-title text-center">Gartner AI Maturity Model</div>
                        <div className={'Maturity-Model-Box'}>
                            <div className="mt-2">
                                <div className="garter-ai-wrap">
                                    <div className="garter-ai-box">
                                        <div className="garter-ai-heading mb-2"> <span>1</span> Planning</div>
                                        <div className="garter-ai-level">AWARENESS</div>
                                        <div className="garter-ai-content">Early AI Interest
                                            with risk of
                                            Overlaping
                                        </div>
                                    </div>
                                    <div className="garter-ai-box">
                                        <div className="garter-ai-heading  mb-2"> <span>2</span> Experimenting</div>
                                        <div className="garter-ai-level">ACTIVE</div>
                                        <div className="garter-ai-content">AI experimentation
                                            mostly in a data
                                            science content </div>
                                    </div>
                                    <div className="garter-ai-box">
                                        <div className="garter-ai-heading  mb-2"> <span>3</span> Stabilization</div>
                                        <div className="garter-ai-level">OPERATIONAL</div>
                                        <div className="garter-ai-content"> AI in production,
                                            creating value by
                                            e.g., process optimization or
                                            productive/service innovations.</div>
                                    </div>
                                    <div className="garter-ai-box">
                                        <div className="garter-ai-heading  mb-2"> <span>4</span> Scaling</div>
                                        <div className="garter-ai-level">SYSTEMIC</div>
                                        <div className="garter-ai-content">AI is pervasively used
                                            for digital process and chain
                                            transformation, and disruptive new digital
                                            business models. </div>
                                    </div>
                                    <div className="garter-ai-box">
                                        <div className="garter-ai-heading  mb-2"> <span>5</span> Leading</div>
                                        <div className="garter-ai-level">TRASFOMATIONAL</div>
                                        <div className="garter-ai-content">AI is part of
                                            business DNA. </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className="text-dark"><strong>AI maturity framework broken down on seven different spectrums</strong></div>
                        <div className="mt-3 page-title text-center">Gartner AI Maturity Model</div>
                        <div className={'Maturity-Model-Box'}>
                            <div className="mt-2">  <div className="garter-ai-main-wrap">
                                <div className="garter-ai-spectrums-list">
                                    <div className="garter-ai-spectrums-list-box ai-strategy">
                                        <div><img src={Images.icon1} alt="" /></div>
                                        <div>AI Strategy</div>
                                    </div>
                                    <div className="ai-value garter-ai-spectrums-list-box">
                                        <div><img src={Images.icon2} alt="" /></div>
                                        <div>AI Value</div>
                                    </div>
                                    <div className=" ai-org garter-ai-spectrums-list-box">
                                        <div><img src={Images.icon3} alt="" /></div>
                                        <div>AI Organization</div>
                                    </div>
                                    <div className=" ai-people garter-ai-spectrums-list-box">
                                        <div><img src={Images.icon4} alt="" /></div>
                                        <div>AI People and Culture</div>
                                    </div>
                                    <div className=" ai-governance garter-ai-spectrums-list-box">
                                        <div><img src={Images.icon5} alt="" /></div>
                                        <div>AI Governance</div>
                                    </div>
                                    <div className=" ai-engineering garter-ai-spectrums-list-box">
                                        <div><img src={Images.icon6} alt="" /></div>
                                        <div>AI Engineering</div>
                                    </div>
                                    <div className="ai-data garter-ai-spectrums-list-box">
                                        <div><img src={Images.icon7} alt="" /></div>
                                        <div>AI Data</div>
                                    </div>
                                </div>
                                <div className="garter-ai-wrap ">
                                    <div className="garter-ai-box">
                                        <div className="garter-ai-heading mb-2"> <span>1</span> Planning</div>
                                        <div className="garter-ai-level">AWARENESS</div>
                                        <div className="garter-ai-content">Early AI Interest
                                            with risk of
                                            Overlaping
                                        </div>
                                    </div>
                                    <div className="garter-ai-box">
                                        <div className="garter-ai-heading  mb-2"> <span>2</span> Experimenting</div>
                                        <div className="garter-ai-level">ACTIVE</div>
                                        <div className="garter-ai-content">AI experimentation
                                            mostly in a data
                                            science content </div>
                                    </div>
                                    <div className="garter-ai-box">
                                        <div className="garter-ai-heading  mb-2"> <span>3</span> Stabilization</div>
                                        <div className="garter-ai-level">OPERATIONAL</div>
                                        <div className="garter-ai-content"> AI in production,
                                            creating value by
                                            e.g., process optimization or
                                            productive/service innovations.</div>
                                    </div>
                                    <div className="garter-ai-box">
                                        <div className="garter-ai-heading  mb-2"> <span>4</span> Scaling</div>
                                        <div className="garter-ai-level">SYSTEMIC</div>
                                        <div className="garter-ai-content">AI is pervasively used
                                            for digital process and chain
                                            transformation, and disruptive new digital
                                            business models. </div>
                                    </div>
                                    <div className="garter-ai-box">
                                        <div className="garter-ai-heading  mb-2"> <span>5</span> Leading</div>
                                        <div className="garter-ai-level">TRASFOMATIONAL</div>
                                        <div className="garter-ai-content">AI is part of
                                            business DNA. </div>
                                    </div>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className="text-dark"><strong>Details of AI maturity framework broken down on five different spectrums</strong></div>
                        <div className="page-title text-center"><strong>AI Roadmap at a glance</strong></div>
                        {/* <div className="mt-2 text-center">“Jobs to be Done” that leads to AI Maturity</div> */}
                        <AIEvaluationTable tableData={aiMaturityEval} />
                    </div>
                    <div className="slide-item">
                        <div className="text-dark mb-2"><strong>Current & Target AI Maturity level Questionnaire</strong></div>
                        <div className="my-2">
                            <MaturityLevelAnalyzer companyName={companyName} />
                        </div>
                    </div>
                    <div className="slide-item">
                        <div className="page-title text-center"><strong>Identify the current state of AI Maturity</strong></div>
                        <div className="d-flex align-items-center justify-content-end mt-2 gap-1">
                            <div className="partially-implemented ml-4"><span><img src={Images.inProgress} alt="in-progress" style={{ width: 15 }} /></span> {TaskStatus.PartiallyImplemented}</div>
                            <div className="fully-implemented ml-4"><span><img src={Images.done} alt="done" style={{ width: 15 }} /></span> {TaskStatus.FullyImplemented}</div>

                        </div>
                        <AIEvaluationTable tableData={aiMaturityEval} analyze />
                    </div>
                    <div className="slide-item">
                        <div className="page-title text-center"><strong>Plotting the Current vs. Target Maturity</strong></div>
                        <div className="d-flex align-items-center justify-content-end mt-2">
                            <div className="Current-Maturity"><span></span> Current Maturity</div>
                            <div className="Target-Maturity ml-4"><span></span> Target Maturity</div>
                        </div>
                        <AIEvaluationTable tableData={aiMaturityEval} timeline />
                    </div>
                </Slider>

                {/* 
                <div style={{ textAlign: "center" }}>
                    <button className="slick-arrow slick-prev slick-prev-page" onClick={() => navigate('/company-intro')}>Pred</button>
                    <button className={`slick-arrow slick-next slick-next-page ${currentIndex === 5 ? '' : 'slick-disabled'}`} disabled={currentIndex !== 5} onClick={() => navigate('/gap-analysis')}>Next</button>
                </div> 
                */}
            </>
        );
    };
    return render();
}

export default AIMaturityEvalution;